Postlogin.StudentProgress = (function () {
    const $studentProgressTable = $('#student-progress-table');
    const progressBars = [];

    const setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).data('progress');
                const userId = $(this).data('user-id');
                const bar = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step(state, stepBar) {
                        stepBar.path.setAttribute('stroke', state.color);
                        stepBar.setText(`${Math.round(stepBar.value() * 100)} %`);
                    },
                });
                bar.animate(progress / 100); // Value from 0.0 to 1.0
                progressBars[userId] = bar;
            });
        }
    };

    const initBootstrapTable = function () {
        const assignmentId = $studentProgressTable.data('assignment-id');
        const lessonId = $studentProgressTable.data('lesson-id');

        $studentProgressTable.bootstrapTable({
            formatNoMatches() {
                return 'No activity to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: `/lessons/${lessonId}/assignments/${assignmentId}/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;
                return myParams;
            },
            columns: [
                {
                    title: '',
                    field: 'completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'student',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Written<br>Responses',
                    field: 'written_responses',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Interest',
                    field: 'interest',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Completed',
                    field: 'date_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Progress',
                    field: 'progress',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    let row = result;
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'llll', []);

                    row.cluster += ` - ${row.grade_band}`;
                    if (row.subtitle) {
                        row.cluster += `<br><em>${row.subtitle}</em>`;
                    }

                    const userViewUrl = $studentProgressTable.attr('data-user-view-url').replace(':user_id', row.user_id);
                    row.student = `<a href="${userViewUrl}">${row.first_name} ${row.last_name}</a>`;

                    row.written_responses_raw = row.written_responses;

                    if (row.written_responses.length > 0) {
                        row.written_responses = ''
                            + '<a href="#"'
                            + '    data-toggle="modal"'
                            + `    data-target="#written-response-modal-${row.assignment_id}"`
                            + '    >'
                            + '    <i class="fa fa-comment" aria-hidden="true"></i>'
                            + '</a>'
                            + `<div class="modal demo-modals fade" id="written-response-modal-${row.assignment_id}" tabindex="-1" role="dialog" aria-labelledby="personalized-modal">`
                            + '    <div class="modal-dialog" role="document">'
                            + '        <div class="modal-content">'
                            + '            <div class="modal-header">'
                            + '                <a type="button" class="close" data-dismiss="modal"'
                            + 'aria-label="Close"><span aria-hidden="true">&times;</span></a>'
                            + '                <div class="modal-title">'
                            + '                    Written Responses'
                            + '                </div>'
                            + '            </div>'
                            + '            <div class="modal-body">'
                            + '                <!-- form -->'
                            + '                <div class="row">';

                        for (let x = 0; x < row.written_responses_raw.length; x++) {
                            const writtenResponse = row.written_responses_raw[x];
                            row.written_responses += '<div class="written-response">';
                            if (writtenResponse.instructions) {
                                row.written_responses += `<h2>${writtenResponse.instructions}</h2>`;
                            }
                            if (writtenResponse.question_text) {
                                row.written_responses += `<h3>${writtenResponse.question_text}</h3>`;
                            }
                            row.written_responses += `<p>${writtenResponse.response}</p></div>`;
                        }

                        row.written_responses
                            += ''
                            + '                </div>'
                            + '                <!-- end form -->'
                            + '            </div>'
                            + '        </div>'
                            + '    </div>'
                            + '</div>';
                    }

                    row.percentage_complete = row.progress;
                    if (+row.progress === 100) {
                        row.completed = ' <i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (row.interest === 'positive') {
                        row.interest += ' <i class="fa-regular fa-face-smile text-success" aria-hidden="true"></i>';
                    } else if (row.interest === 'neutral') {
                        row.interest += ' <i class="fa-regular fa-face-meh" aria-hidden="true"></i>';
                    } else if (row.interest === 'negative') {
                        row.interest += ' <i class="fa-regular fa-face-frown text-danger" aria-hidden="true"></i>';
                    }

                    row.progress = ''
                        + '<div'
                        + '    class="progress-indicator hidden-print"'
                        + `    id="student-progress-${row.user_id}"`
                        + `    data-progress="${row.progress}"`
                        + `    data-user-id="${row.user_id}"`
                        + '    ></div>'
                        + `<span class="visible-print">${row.progress}%</span>`;
                });

                return formattedResult;
            },
            onLoadSuccess() {
                setupProgressBars();
            },
            rowStyle(row) {
                let classes = '';
                if (row.percentage_complete < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_complete < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_complete < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    const init = function () {
        initBootstrapTable();
    };

    return {
        init,
    };
}());
